/**
 * fix iOS输入框获取焦点时滚动屏幕，光标卡在焦点时位置。
 */
export default function fixIosCursor() {
    if (Bowser.getParser(window.navigator.userAgent).getOS().name === 'iOS') {
        document.addEventListener('scroll', function () {
            if (document.activeElement.tagName === 'INPUT' ||
                document.activeElement.tagName === 'TEXTAREA') {
                setTimeout(function () {
                    document.activeElement.blur();
                }, 100);
            }
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/m/fixIosCursor.js
// module id = null
// module chunks = 